import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection';
import './SupportSection.scss';
import supportBg from '../../assets/images/church/verse-hero.png';

const SupportSection = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const prefersReducedMotion = useReducedMotion();

    const { scrollYProgress } = useScroll({
        target: sectionRef,
        offset: ['start end', 'end start'],
    });

    const bgY = useTransform(scrollYProgress, [0, 1], ['0%', '-15%']);

    const fadeUp = (delay, duration = 1.0, extra = {}) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20, ...extra },
                  whileInView: { opacity: 1, y: 0, scale: 1 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <section className="support-section" ref={sectionRef}>
            <motion.div
                className="support-section__bg"
                style={{
                    backgroundImage: `url(${supportBg})`,
                    y: prefersReducedMotion ? 0 : bgY,
                }}
            />
            <div className="support-section__container">
                <motion.h2
                    className="support-section__title"
                    {...fadeUp(0, 1.2, { scale: 0.99 })}
                >
                    {t('support_church')}
                </motion.h2>
                <motion.p className="support-section__description" {...fadeUp(0.25)}>
                    {t('support_description')}
                </motion.p>
                <motion.div {...fadeUp(0.45, 0.9)}>
                    <a
                        href="https://usaregeneration.churchcenter.com/giving"
                        className="button button--outline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('give_online')}
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default SupportSection;
